{
  "collapse": "Skjul",
  "expand": "Utvid"
}
